import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import Title from "./Title";
import List, { Item } from "./List";
import { globalStyles } from "../../views/Resume";

const styles = StyleSheet.create({
  entryContainer: {
    marginBottom: "2px",
  },
  date: {
    fontSize: 4,
    fontFamily: "Lato Italic",
  },
  detailLeftColumn: {
    flexDirection: "column",
    marginLeft: 10,
    marginRight: 10,
  },
  detailRightColumn: {
    flexDirection: "column",
    flexGrow: 9,
  },
  bulletPoint: {
    fontSize: 8,
  },
  details: {
    fontSize: 6,
    fontFamily: "Lato",
  },
  headerContainer: {
    flexDirection: "row",
    marginBottom: 2,
  },
  leftColumn: {
    flexDirection: "column",
    flexGrow: 9,
  },
  rightColumn: {
    flexDirection: "column",
    flexGrow: 1,
    alignItems: "flex-end",
    justifySelf: "flex-end",
  },
  title: {
    fontSize: 6,
    fontFamily: "Lato Bold",
  },
  bold: {
    fontSize: 6,
    fontFamily: "Lato Bold",
  },
});

const ExperienceEntry = ({ company, details, position, date, skills }) => {
  const title = `${company} | ${position}`;
  return (
    <View style={styles.entryContainer}>
      <View style={styles.headerContainer}>
        <View style={styles.leftColumn}>
          <Text style={styles.title}>{title}</Text>
        </View>
        <View style={styles.rightColumn}>
          <Text style={styles.date}>{date}</Text>
        </View>
      </View>
      <List>
        {details.map((detail) => (
          <Item key={detail}>
            <Text style={styles.details}>{detail}</Text>
          </Item>
        ))}
        <Item>
          <Text style={styles.bold}>Tech Stack: </Text>
          <Text style={styles.details}>{skills.join(", ")}</Text>
        </Item>
      </List>
    </View>
  );
};

const Experience = ({ experienceData }) => (
  <View style={globalStyles.container}>
    <View>
      <Title>Professional Experience</Title>
    </View>
    {experienceData.map(({ company, date, details, position, skills }) => (
      <ExperienceEntry
        company={company}
        date={date}
        details={details}
        key={company + position}
        position={position}
        skills={skills}
      />
    ))}
  </View>
);

export default Experience;
